import { Trans } from '@lingui/react/macro';
import { DockPointer } from '@src/navigation/DockPointer';
import { useDockNavigation } from '@src/navigation/useDockNavigation';
import { Task, TypeId, isTypeId } from '@sdk';
import { useEffect } from 'react';

/**
 * Transition shim for the retired `ViewType.TASKS`. Task now opens through the
 * generic asset editor; this redirects any lingering `/dock/tasks/<id>` deep
 * link (bookmarks, emails, notifications) to `editor/task/typeid/task-<id>`.
 */
export function TasksRedirect() {
  const { navigation, currentDock } = useDockNavigation();
  const pointer = currentDock?.pointer;

  useEffect(() => {
    const head = pointer?.split('/')[0];
    const typeId = head ? (isTypeId(head) ? new TypeId(head) : new TypeId(Task.type, head)) : null;
    navigation.replaceDock(
      typeId ? DockPointer.forAssetEditorByTypeId('task', typeId) : DockPointer.forAssetList('task'),
    );
  }, [pointer, navigation]);

  return (
    <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
      <Trans>Loading…</Trans>
    </div>
  );
}
